<template lang="pug">
  v-card.mt-5.full-width(width="100")
    Header(
      icon="gifts",
      :to="{ name: 'redeemables' }",
    )
    FormWrapper(type="redeemable")
      template( v-slot:default="props")
        RedeemableForm(
          :model="props.model",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Header from '@/components/forms/Header.vue';
import RedeemableForm from '@/components/forms/Redeemable.vue';

export default {
  components: {
    FormWrapper,
    Header,
    RedeemableForm,
  },
};
</script>
